// extracted by mini-css-extract-plugin
module.exports = {"alert":"iu","alertIcon":"iv","formContainer":"iw","formContainerInner":"ix","successIcon":"iy","footer":"iz","footerItem":"iA"};